// src/context/SyncDataContext.jsx
import React, { createContext, useContext } from 'react';
import { useSyncData } from '../hooks/useSyncData';
import { useAuth } from '../hooks/useAuth';
import { ROLE_ADMIN } from '../utils/rolePermissions';

// Create a context for sync data functionality
export const SyncDataContext = createContext(null);

// Provider component that wraps the application and makes sync data available to any child component
export const SyncDataProvider = ({ children }) => {
  const { isAuthenticated, role } = useAuth();

  // The sync detail endpoints are admin-only, and this provider wraps the whole
  // app — polling them for a staff account produced six "Failed to load ... sync
  // details" toasts on every page. Being logged in is not enough; the account
  // has to be one the server will answer.
  const canReadSyncData = isAuthenticated && role === ROLE_ADMIN;

  const syncData = useSyncData(canReadSyncData);
  
  return (
    <SyncDataContext.Provider value={syncData}>
      {children}
    </SyncDataContext.Provider>
  );
};

// Custom hook that allows easy consumption of the sync data context
export const useSyncDataContext = () => {
  const context = useContext(SyncDataContext);
  
  if (context === null) {
    throw new Error('useSyncDataContext must be used within a SyncDataProvider');
  }
  
  return context;
};